import React from 'react';
import EditableField from './EditableField';
import EditableDropdown from './EditableDropdown';
import LoadableIcon from './LoadableIcon';
import ButtonDelete from './ButtonDelete';
import ButtonAction from './ButtonAction';
import EntityForm from './EntityForm';
import { ButtonGroup } from 'reactstrap';
import { CONFORMANCE_FIELDS } from '../constants/Fixtures';
import { matchesDateString, matchesURL } from '../helpers/Validations';
import * as warnings from '../constants/ValidationWarnings';

export default class Conformance extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      loading: false,
      warning: ''
    };
  }

  clickConformanceHandle = () => {
    this.setState({ editing: true });
  }

  clearEdit = () => {
    this.setState({ editing: false });
  }

  // no validation atm
  validateConformanceName(name) {
    return /^.+$/.test(name);
  }

  conformanceGroup = () => [
    {
      category: 'description',
      content: this.props.description,
      validation: this.validateConformanceName,
      editTitle: "Enter the text description or URL of the conformance level.",
    },
    {
      category: 'organization',
      content: this.props.organization,
      validation: () => true,
      editTitle: "Enter the certifying organization. This will not be included in the ePub if using a URL for the description.",
    },
    {
      category: 'credential',
      content: this.props.credential,
      validation:  () => true,
      editTitle: "Enter the certifying credentials. This can be a link or a short description.",
    },
    {
      category: 'report',
      content: this.props.report,
      validation: matchesURL,
      warning: warnings.URL_STRING,
      editTitle: "Enter a link to a certifier report.",
    },
    {
      category: 'certdate',
      content: this.props.certdate,
      validation: matchesDateString,
      warning: warnings.DATE_STRING,
      editTitle: "Enter the certification date.",
    },
  ]

  disabledConditions = () => [
    {
      controller: 'description',
      targeted: ['organization', 'credential', 'report', 'certdate'],
      type: 'match',
      validation: '^http(s)?://',
      message: '[Unused for URL Descriptions]'
    },
    {
      controller: 'organization',
      targeted: ['credential', 'report', 'certdate'],
      type: 'novalue',
      message: '[No certifying organization]'
    }
  ]

  destroy = () => {
    this.setState({
      loading: true,
    });
    this.props.destroy(this.props.id);
  }

  updateConformance = (attributes) => {
    this.props.update(this.props.id, attributes);
    this.setState({ editing: false });
  }

  handleDisabled(name){
    const DISABLED_CONDITIONS = this.disabledConditions();
    if (!DISABLED_CONDITIONS){return false;}
    const matchingConditions = DISABLED_CONDITIONS.filter((i) => i.targeted.includes(name))
    if (!matchingConditions){return false;}

    for (var i in matchingConditions){
      var matchingCondition = matchingConditions[i];
      if (matchingCondition.type == 'match'){
        if (new RegExp(matchingCondition.validation).test(this.props[matchingCondition.controller])){
          return matchingCondition.message;
        }
      } else if (matchingCondition.type == "novalue"){
        if (!this.props[matchingCondition.controller]){
          return matchingCondition.message;
        }
      }
    }
    return false;
  }

  handleValidation = (attr, input) => {
    var conf = this.conformanceGroup().find((i) => i.category == attr);
    var warning = "";
    var valid = true;

    if (!conf.validation(input) && conf.warning && input.length > 0){
      warning += conf.warning + ' ';
      valid = false;
    }

    this.setState({ warning: warning });
    return valid;
  }

  render(){
    const convElements = this.conformanceGroup().reduce((acc, item) => {
      let {category, content} = item;
      return {...acc, [category]: content};
    }, {category: this.props.type});

    if (this.state.editing) {
      return (
        <EntityForm
          key={`${this.props.title || 'conformance'}-form-${this.state.formIndex}`}
          fields={CONFORMANCE_FIELDS}
          action={this.updateConformance}
          validate={this.handleValidation}
          warning={this.state.warning}
          formElements={convElements}
        />
      );
    }
    else{
      return(
        <tr>
          {this.conformanceGroup().map(item =>
            (<td
              className="item-name creator-field"
              key={item.category}
            >
              { this.handleDisabled(item.category) ? <span className="empty-field">{this.handleDisabled(item.category)}</span> : (item.content ? item.content : <span className="empty-field">[empty]</span>)}
            </td>),
          )}
          <td className="section-table-remove">
            <ButtonGroup size='sm'>
              <ButtonAction
                size='sm'
                title='Edit conformance'
                id={`conformance-${this.props.id}`}
                className="btn-edit"
                action={this.clickConformanceHandle}
                type="button"
                icon="fa-pencil"
                color="secondary"
              />
              <ButtonDelete
                size='sm'
                title='Remove conformance'
                id={`conformance-${this.props.id}`}
                action={this.destroy}
                noConfirm
              />
            </ButtonGroup>
          </td>
        </tr>
      );
    }
  }
}
